import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './ui/FadeIn';
export function ProblemSection() {
  return <section id="nosotros" className="py-16 bg-cream relative" data-id="element-275">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-276">
        <FadeIn data-id="element-277">
          <p className="text-xl md:text-2xl font-serif text-deep-brown leading-relaxed mb-8 text-center italic" data-id="element-278">
            "Usted invirtió semanas organizando cada detalle del evento. Todo
            pensado. Todo cuidado. Y entonces llega el catering."
          </p>
        </FadeIn>

        <StaggerContainer className="grid gap-5 mb-12" data-id="element-279">
          <StaggerItem data-id="element-280">
            <div className="bg-warm-white p-6 md:p-8 rounded-sm shadow-sm border-l-4 border-terracotta" data-id="element-281">
              <p className="text-lg text-deep-brown font-medium" data-id="element-282">
                Bandejas que parecen del día anterior.
              </p>
            </div>
          </StaggerItem>
          <StaggerItem data-id="element-283">
            <div className="bg-warm-white p-6 md:p-8 rounded-sm shadow-sm border-l-4 border-terracotta" data-id="element-284">
              <p className="text-lg text-deep-brown font-medium" data-id="element-285">
                Productos genéricos sin identidad.
              </p>
            </div>
          </StaggerItem>
          <StaggerItem data-id="element-286">
            <div className="bg-warm-white p-6 md:p-8 rounded-sm shadow-sm border-l-4 border-terracotta" data-id="element-287">
              <p className="text-lg text-deep-brown font-medium" data-id="element-288">
                Una presentación que no está a la altura de todo lo demás.
              </p>
            </div>
          </StaggerItem>
        </StaggerContainer>

        <FadeIn delay={0.2} className="text-center" data-id="element-289">
          <p className="text-lg text-brown-medium max-w-2xl mx-auto mb-4" data-id="element-290">
            La mesa es la primera impresión física de sus invitados. La tocan.
            La fotografían. La prueban. Y la juzgan en silencio.
          </p>
          <p className="text-lg font-medium text-deep-brown max-w-2xl mx-auto" data-id="element-291">
            La mayoría de los caterings están optimizados para escalar, no para
            impresionar. Por eso todo se ve igual.
          </p>
        </FadeIn>
      </div>
    </section>;
}